import { getCLS, getFID, getLCP } from 'web-vitals';
import { sendBeaconWebVitals } from '../events/performance-webvitals';

const body = new Set();
const addToQueue = metric => body.add(metric);

export const webVitalsInit = (config, client) => {
  [getCLS, getFID, getLCP].forEach(fn => fn(addToQueue));

  window.addEventListener('beforeunload', () => {
    sendBeaconWebVitals({ config, client, body });
    body.clear();
  });
};
